<template>
    <v-layout  column class="dd-page">
        <v-layout  d-flex>
            <v-flex v-if="!hideBreadcrumbs"  class="dd-dark white--href" >             
                <v-breadcrumbs class="pr-3 dd-breadcrumbs" divider="-" :items="breadcrumbs" v-if="breadcrumbs"  dark >
                </v-breadcrumbs>                                     
            </v-flex>
        </v-layout>
        <v-layout row d-flex white elevation-13 wrap >
            <slot name="left-info" v-if="leftInfo">
                <v-flex accent align-center py-2 px-4 column d-flex >   
                {{title}}
                </v-flex>
            </slot>            
            <v-layout column  >                                    
                <v-flex accent align-center py-2 px-4 column d-flex v-if="title">   
                    <v-layout row wrap d-flex >
                        
                    
                    <v-flex d-flex ><h4>{{title}}</h4>
                        
                    </v-flex>
                    
                    <v-flex d-flex justify-end="">
                        <div class="dd-page-button-top-right"  >
                            <slot name="button-top-right" d-flex></slot>
                        </div>    
                    </v-flex>    
                    </v-layout>               
                </v-flex>
                
                <v-flex wrap flex > 
                    <v-flex class="" white>                    
                        
                    </v-flex>
                    <slot name="content">                  
                    </slot>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-layout>
</template>
<script>
import { mapGetters } from 'vuex'
import * as types from "../../store/types"

export default {
  props:{
      leftInfo: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
  },
  data () {
   return{}
  },
  computed: {
    ...mapGetters({
      breadcrumbs: types.CURRENT_BREADCRUMBS,
      hideBreadcrumbs: types.HIDE_BREADCRUMBS
    }),
  }
}
</script>
<style scoped>
    .dd-page{        
        margin-top: -102px !important;        
    }

    .dd-breadcrumbs a {
        color: #fff;
    }
    


    .dd-page-button-top-right {
        position:absolute;
        margin-top: 2px;    
        z-index: 100;
    }
</style>